module.exports = __webpack_public_path__ + "img/paas_wrapbg3.64430f43.png";